import React, { useEffect, useState } from "react";
import NotesContainer from "../Notes/NotesContainer";
import { collection, query, orderBy, limit, where, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { CircularProgress } from "@mui/material";

function CbtNotesContainer() {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const notesRef = collection(db, "notes");
    const q = query(
      notesRef,
      where("noteType", "==", "cbtNote"),
      orderBy("sessionDateTime", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = [];
      querySnapshot.forEach((doc) => {
        notesData.push({ id: doc.id, ...doc.data() });
      });
      setNotes(notesData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : notes.length === 0 ? (
        <div
          style={{
            border: "1px dashed #cbd5e1",
            borderRadius: 12,
            padding: "24px 20px",
            background: "#f8fafc",
            color: "#475569",
            textAlign: "center",
            fontSize: 14,
          }}
        >
          No CBT notes yet. Add your first one to get started.
        </div>
      ) : (
        notes.map((note) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedDate = note.sessionDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.sessionDateTime.toDate()
              )
            : "";

          return (
            <div style={{ paddingBottom: "15px" }} key={note.id}>
              <NotesContainer
                noteContent={
                  <div>
                    <div><strong>Session number:</strong> {note.sessionNumber}</div>
                    <div><strong>Presentation:</strong> {note.presentation}</div>
                    <div><strong>Treatment goal:</strong> {note.treatmentGoal}</div>
                  </div>
                }
                effectiveDate={note.sessionDateTime}
                noteDate={formattedDate}
                noteTime=""
                doneBy={note.doneBy}
                timeStamp={formattedDate}
                lastModification=""
                noteId={note.id}
                noteType={note.noteType}
                sessionDateTime={note.sessionDateTime}
                sessionNumber={note.sessionNumber}
                presentation={note.presentation}
                treatmentGoal={note.treatmentGoal}
                fileUrls={note.fileUrls || []}
                clientId={note.clientId}
                clientFirstName={note.clientFirstName}
                clientLastName={note.clientLastName}
                clientProfilePicture={note.clientProfilePicture}
                {...note}
              />
            </div>
          );
        })
      )}
    </div>
  );
}

export default CbtNotesContainer;
